var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoLibelula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_libelula",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_96",
    "data-name": "Rect\\xE1ngulo 96",
    width: 80,
    height: 80,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_312",
    "data-name": "Trazado 312",
    d: "M84.22,91.508c-1.735-1.3-3.437-2.644-5.22-3.873-1.181-.814-2.5-1.434-3.72-2.189a20.067,20.067,0,0,0-7.367-2.767,1.313,1.313,0,0,0,.032.23A10.925,10.925,0,0,0,72.8,88.829a22.632,22.632,0,0,0,8.673,2.78c.983.123,1.976.161,2.964.238a.571.571,0,0,0-.217-.338",
    transform: "translate(-45.87 -55.845)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_313",
    "data-name": "Trazado 313",
    d: "M121.839,110.247a.834.834,0,0,0-1.048-.378c-.437.312-.839.673-1.251,1.019a.846.846,0,0,0-.124.2,3.29,3.29,0,0,1-.435.66c-.7.66-1.427,1.3-2.156,1.931a1.56,1.56,0,0,0-.585,2.072c.345-.05.891.037,1.153-.2.9-.8,1.687-1.72,2.535-2.577.228-.23.525-.389.774-.6a6.109,6.109,0,0,0,.635-.615c.144-.163.209-.411.375-.535.4-.3.314-.641.127-.982",
    transform: "translate(-78.385 -74.157)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_314",
    "data-name": "Trazado 314",
    d: "M98.794,60.057c1.132,1.029,2.37,1.94,3.642,2.971a1.859,1.859,0,0,0,.016-.3c-.093-.41-.187-.82-.287-1.229a52.222,52.222,0,0,0-6.507-14.726A33.634,33.634,0,0,0,93.6,43.891a7.621,7.621,0,0,0-1.044-1.007c-.223-.2-.429-.136-.52.148a6.076,6.076,0,0,0-.289,1.076,14.923,14.923,0,0,0,1.219,8.252,24.08,24.08,0,0,0,5.829,7.7",
    transform: "translate(-61.88 -28.887)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_315",
    "data-name": "Trazado 315",
    d: "M137.225,101.732a1.055,1.055,0,0,0,1.574-1.018c-.032-.519-.5-.875-.982-1.208a1.028,1.028,0,0,0-1.435,1.379,3.126,3.126,0,0,0,.843.847",
    transform: "translate(-92.02 -67.101)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_316",
    "data-name": "Trazado 316",
    d: "M40,0A40,40,0,1,0,80,40,40,40,0,0,0,40,0M65.831,50.982a10.633,10.633,0,0,1-4.683.609,17,17,0,0,1-6.682-1.712,26.589,26.589,0,0,1-2.286-1.375,11.423,11.423,0,0,0-1.133-.714c.088.161.177.322.263.484a31.427,31.427,0,0,1,3.078,7.213,8.154,8.154,0,0,1,.229,1.535,2.013,2.013,0,0,1-2.637,2.25,9.9,9.9,0,0,1-4-2.013,16.643,16.643,0,0,1-5.856-9.542c-.408-1.594-.628-3.236-.933-4.856-.015-.078-.031-.155-.05-.247a11.592,11.592,0,0,1-1.2.806,2.29,2.29,0,0,1-1.062.29,1.365,1.365,0,0,0-1.081.509q-8.269,8.2-16.546,16.4a2.217,2.217,0,0,1-1.8.781,1.95,1.95,0,0,1-1.673-1.4v-.876a12.129,12.129,0,0,1,1.075-1.463q8.124-8.241,16.27-16.461a2.228,2.228,0,0,0,.352-.745c.218-.547.4-1.107.646-1.644a3.293,3.293,0,0,1,.495-.619c-.159-.031-.251-.057-.344-.066a27.637,27.637,0,0,1-5.841-1.188,16.243,16.243,0,0,1-8.492-5.519,9.449,9.449,0,0,1-2.081-4.169,2.042,2.042,0,0,1,2.2-2.549,10.745,10.745,0,0,1,2.425.441,29.678,29.678,0,0,1,5.887,2.62c.314.172.64.323,1.015.511-.6-.986-1.209-1.87-1.706-2.812a16.122,16.122,0,0,1-1.672-11.007c.257-1.263.678-2.509,2.22-2.809h.195c1.887.412,2.977,1.839,3.982,3.282A58.152,58.152,0,0,1,41.3,28.58c.405,1.125.743,2.275,1.125,3.457.081-.13.147-.232.209-.335a3.347,3.347,0,0,1,2.856-1.659.782.782,0,0,0,.511-.308,2.686,2.686,0,0,1,1.486-1.11c.96-.272,1.839.124,1.7,1.359a1.2,1.2,0,0,1,1.326.414,1.468,1.468,0,0,1,.079,1.395,2.557,2.557,0,0,1-1.183,1.425c-.124.074-.278.249-.271.368a3.071,3.071,0,0,1-1.831,3.143.655.655,0,0,0-.1.093c.234.076.443.149.656.212A60.976,60.976,0,0,1,63.5,44.268a13.424,13.424,0,0,1,3.28,2.795c.031.038.062.075.091.114,1.235,1.647.862,3.03-1.043,3.806",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_317",
    "data-name": "Trazado 317",
    d: "M135.134,127.052c-.54-.695-1.122-1.356-1.776-2.144,0,.314-.015.471,0,.625.153,1.4.222,2.816.486,4.195a19.4,19.4,0,0,0,3.125,7.882,10.921,10.921,0,0,0,5.424,3.959c-.014-.176-.013-.272-.03-.365a16.858,16.858,0,0,0-1.506-4.8,59.154,59.154,0,0,0-5.727-9.349",
    transform: "translate(-90.071 -84.367)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_318",
    "data-name": "Trazado 318",
    d: "M147.822,94.255l-.215-.2-.551.44.334.365.432-.6",
    transform: "translate(-99.328 -63.528)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_319",
    "data-name": "Trazado 319",
    d: "M150.159,123.1a46.124,46.124,0,0,0-9.986-3.839c-.436-.112-.878-.2-1.408-.325a27.34,27.34,0,0,0,4.229,5.073,25.2,25.2,0,0,0,5.768,4.172,14.763,14.763,0,0,0,7.957,1.53,4.372,4.372,0,0,0,2.494-.792c-.773-.651-1.446-1.277-2.178-1.823a50.766,50.766,0,0,0-6.876-4",
    transform: "translate(-93.727 -80.332)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLibelula);
export default __webpack_public_path__ + "static/media/ico_libelula.0960a63c474ddb4b5b857e14389d394b.svg";
export { ForwardRef as ReactComponent };